
        <div [ngStyle]="contentStyle$ | async">
            <siq-video-player #videoPlayer (completed)="completed.emit()"></siq-video-player>
            <siq-image-player #imagePlayer (completed)="completed.emit()"></siq-image-player>
        </div>

        <!-- The iframe can always be there. It is not visible if srcdoc is empty.
             But creating the iframe too often can lead to problems with older browsers like on gilbarco platform. -->
        <iframe [srcdoc]="htmlCode$ | async"></iframe>
    